<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>分销设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        :model="distributionForm"
        :rules="rules"
        ref="distributionForm"
        label-width="98px"
        class="distribution-form"
        size="medium"
        :hide-required-asterisk="true"
        status-icon
      >
        <el-form-item label="分销开关">
          <el-switch
            v-model="distributionForm.distributionToggle"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="分销模式">
          <el-radio-group v-model="distributionForm.distributionMode">
            <el-radio :label="1">商品模式</el-radio>
            <el-radio :label="2">标准模式</el-radio>
          </el-radio-group>
          <span class="tips"
            >说明：<span class="warning"
              >标准模式：分销关系一次绑定后永久关系 &nbsp; &nbsp;/ &nbsp;&nbsp;
              商品模式：分销关系通过商品分享，单次实时绑定。</span
            ></span
          >
        </el-form-item>
        <el-form-item label="提现开关">
          <el-switch
            v-model="distributionForm.withdrawToggle"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          关闭提现，余额只能消费
        </el-form-item>
        <el-form-item label="分成方式">
          <el-radio-group v-model="distributionForm.distributionType">
            <el-radio :label="1">固定金额</el-radio>
            <el-radio :label="2">按比例</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="固定分成"
          prop="fixedDistribution"
          v-show="distributionForm.distributionType == 1"
        >
          <el-input
            type="text"
            placeholder="多少元"
            v-model="distributionForm.fixedDistribution"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="distributionForm.distributionType == 2"
          label="佣金比例"
          prop="distributioPercentage"
        >
          <el-input
            type="text"
            placeholder="比例0-99"
            v-model="distributionForm.distributioPercentage"
          ></el-input>
          <span class="tips"
            ><span class="warning">输入0-99，按订单支付金额分成</span></span
          >
        </el-form-item>
        <el-form-item label="分佣时间" prop="distributionDay">
          <el-input
            type="text"
            placeholder="确定订单后多久分佣(天)"
            v-model="distributionForm.distributionDay"
          ></el-input>
          <span class="tips"><span class="warning">以天为单位</span></span>
        </el-form-item>
        <el-form-item label="提现最低额度" prop="withdrawMinBalance">
          <el-input
            type="text"
            placeholder="满多少可提现"
            v-model="distributionForm.withdrawMinBalance"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请标题" prop="title">
          <el-input
            type="text"
            placeholder="申请标题"
            v-model="distributionForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请规则" prop="" style="height: 300px">
          <quill-editor
            v-model="distributionForm.rule"
            ref="quillEditor"
            :options="editorOption"
          >
          </quill-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('distributionForm')"
            >确认修改</el-button
          >
          <el-button type="primary" plain @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getDistributionConfig, updateDistributionConfig } from "@/api";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      distributionForm: {
        distributionToggle: 1,
        withdrawToggle: 1,
        distributionType: 1,
        distributionMode: 1,
        title: "",
        rule: "",
        distributioPercentage: "",
        fixedDistribution: "",
        withdrawMinBalance: "",
        distributionDay: "",
      },
      rules: {
        // title: [
        //   {
        //     required: true,
        //     message: "请填写分销标题",
        //     trigger: "blur",
        //   },
        // ],
        // rule: [
        //   {
        //     required: true,
        //     message: "请填写分销规则",
        //     trigger: "blur",
        //   },
        // ],
        // distributioPercentage: [
        //   {
        //     required: true,
        //     message: "请填写分成比例",
        //     trigger: "blur",
        //   },
        // ],
        // fixedDistribution: [
        //   {
        //     required: true,
        //     message: "请填写固定分成",
        //     trigger: "blur",
        //   },
        // ],
        // withdrawMinBalance: [
        //   {
        //     required: true,
        //     message: "请填写提现最低额度",
        //     trigger: "blur",
        //   },
        // ],
        // distributionDay: [
        //   {
        //     required: true,
        //     message: "请填写分佣时间",
        //     trigger: "blur",
        //   },
        // ],
      },
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
        },
        placeholder: "分销规则",
      },
    };
  },
  components: {
    quillEditor,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  watch: {
    "distributionForm.distributioPercentage": {
      handler: function(newval, oldval) {
        if (isNaN(newval)) {
          this.distributionForm.distributioPercentage = oldval;
        } else {
          console.log(newval);
          if (newval < 0) {
            this.distributionForm.distributioPercentage = 0;
            this.$notify.warning("值不能小于0");
            return;
          }
          if (newval > 99) {
            this.distributionForm.distributioPercentage = Number(oldval);
            this.$notify.warning("值不能大于99");
            return;
          }
          this.distributionForm.distributioPercentage = Number(newval);
        }
      },
    },
    "distributionForm.fixedDistribution": {
      handler: function(newval, oldval) {
        if (isNaN(newval)) {
          this.distributionForm.fixedDistribution = oldval;
        } else {
          this.distributionForm.fixedDistribution = Number(newval);
        }
      },
    },
    "distributionForm.distributionDay": {
      handler: function(newval, oldval) {
        if (isNaN(newval)) {
          this.distributionForm.distributionDay = oldval;
        } else {
          this.distributionForm.distributionDay = Number(newval);
        }
      },
    },
    "distributionForm.withdrawMinBalance": {
      handler: function(newval, oldval) {
        if (isNaN(newval)) {
          this.distributionForm.withdrawMinBalance = oldval;
        } else {
          this.distributionForm.withdrawMinBalance = Number(newval);
        }
      },
    },
    shopInfo(val) {
      if (this.shopInfo.edcShopType != 2) {
        this.distributionForm.distributionMode = 2;
      }
    },
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    submitForm(formName) {
      if (
        this.shopInfo.edcShopType != 2 &&
        this.distributionForm.distributionMode == 1
      ) {
        this.distributionForm.distributionMode = 2;
        this.$message.error("餐饮类只能选择标准模式");
      }
      if (this.distributionForm.distributionMode == 2) {
        if (this.distributionForm.distributioPercentage === "") {
          return this.$message.error("佣金比例不能为空");
        }
        if (this.distributionForm.distributionDay === "") {
          return this.$message.error("分佣时间不能为空");
        }
      }
      console.log(this.distributionForm);
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {
      updateDistributionConfig(this.distributionForm).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "修改成功",
            type: "success",
            duration: 2000,
          });
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
      //     } else {
      //       this.$notify({
      //         title: "提示",
      //         message: "请完善提交内容",
      //         type: "error",
      //         duration: 2000,
      //       });
      //       return false;
      //     }
      //   });
    },
    getConfig() {
      getDistributionConfig().then((res) => {
        console.log(res);
        if (res.code == 1) {
          if (res.data.rule) {
            res.data.rule = this.escapeStringHTML(res.data.rule);
          }
          Object.assign(this.distributionForm, res.data);
          console.log(this.distributionForm);
          if (this.shopInfo.edcShopType != 2) {
            this.distributionForm.distributionMode = 2;
          }
        }
      });
    },
    resetForm() {
      this.distributionForm = {
        distributionToggle: 1,
        withdrawToggle: 1,
        distributionType: 1,
        distributionMode: 1,
        title: "",
        rule: "",
        distributioPercentage: "",
        fixedDistribution: "",
        withdrawMinBalance: "",
        distributionDay: "",
      };
      this.$refs.distributionForm.resetFields();
    },
    escapeStringHTML(str) {
      str = str.replace(/&lt;/g, "<");
      str = str.replace(/&gt;/g, ">");
      return str;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    height: calc(100% - 39px);
    padding: 20px;
    overflow: auto;
    box-sizing: border-box;
    .tips {
      margin-left: 20px;
      .warning {
        color: red;
      }
    }
    .distribution-form {
      .el-input {
        width: 200px;
      }
      .quill-editor {
        width: 800px;
        height: 200px;
      }
    }
  }
}
</style>
